import { useMemo } from "react";
import { useQueries } from "@tanstack/react-query";
import { q_profile_info } from "../queries/queries.jsx";
import { nils, getv } from "../utils/utils.jsx";

export const useProfileData = (vault) => {
  const [qo] = useQueries({
    queries: [q_profile_info({ vault }, { enabled: !nils(vault) })],
  });

  const profile = useMemo(() => {
    return getv(qo, "data.result");
  }, [qo]);

  return profile;
};

